(function($){

  var context = {

    init: function(){
      $(".toggle-button").click( context.toggleBtn );
    },

    toggleBtn: function(ev) {
      var websiteToken = $(this).data("website");
      var toggles = $(this).data("toggles");
      var model = $(this).data("model");

      if( model === "website"){
        $.ajax({
          url: '/ajax/toggle_website_property',
          data: {
            website: websiteToken,
            toggle: toggles
          },
          error: function(data){
            alert('Error: ' + data.responseJSON.error);
          }
        });
      }

      if ( model === "button"){
        $.ajax({
          url: '/ajax/toggle_button_live',
          data: {
            website: websiteToken,
            button: toggles
          }
        });
      }

      if ( model === "offer-channel"){
        var offer = $(this).data('offer')
        $.ajax({
          url: '/ajax/toggle_offer',
          data: {
            website: websiteToken,
            offer: offer,
            channel: toggles
          }
        });
      }
    }

  }

  context.init();

})(jQuery);
